import { call, takeEvery } from 'redux-saga/effects';
import { fetchEntity } from '@classpass/saga-tools';
import { recommendations as recommendationsEntity } from 'store/saga/entities/bound';
import { trackHomeOpportunityClicked } from 'helpers/events';

export const RECOMMENDATION_CLICK = 'RECOMMENDATION_CLICK';

export const trackRecommendationClick = (venueId, dashboardUserId, recommendationName, shareType) => ({
  type: RECOMMENDATION_CLICK,
  venueId,
  dashboardUserId,
  recommendationName,
  ...(shareType && { shareType }),
});

export function* doFetchRecommendationData(client, action) {
  const { userId, venueId } = action;
  yield call(fetchEntity, recommendationsEntity, [client, { userId, venueId }]) || {};
}

export function* doTrackRecommendationClick(client, action) {
  const { dashboardUserId, venueId, recommendationName, shareType } = action;
  yield call(trackHomeOpportunityClicked, venueId, dashboardUserId, recommendationName, shareType);
}

export function* watchRecommendationClicks(dependencies) {
  yield takeEvery(RECOMMENDATION_CLICK, doTrackRecommendationClick, dependencies);
}
